export class FindIdPUser {
	id: number;
	username: string;
	idpId: number;
	userId: string;
	page: number;
	pageSize: number;

	constructor(){
		this.id = 0;
		this.username = '';
		this.idpId = 0;
		this.userId = '';
		this.page = 0;
		this.pageSize = 0;
	}
}
